import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EnregistrerPage } from './enregistrer';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DirectivesModule } from '../../directives/directives.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    EnregistrerPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(EnregistrerPage),
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient]
        }
    })
  ]
})
export class EnregistrerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/enregistrer/enregistrer.module.ts